module.exports = __webpack_public_path__ + "static/img/icon_java.d3cc233a.svg";